import ppt1 from "../../assets/images/ppt-1.png";
import ppt2 from "../../assets/images/ppt-2.png";

export const THEMES = [
  { id: 0, label: "Dabur Theme - 1", colors: ["#1B5C29", "#9CA3AF", "#E5E7EB"] },
];

export const TEMPLATES = [
  { id: "t1", label: "Template - 1", images: [ppt1, ppt2] },
];

 